// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 723) return "static/css/723.b4885f4b4.chunk.css";
	// return url for filenames based on template
	return undefined;
};